import { API, formatApiError } from "@/lib/api";

export const TOPIC_LABELS = { attendance: "Attendance", payroll: "Payroll", performance: "Performance" };
export const companyLabel = (company) => ({ ALL: "All companies", NAVARATNAA: "Navaratnaa", SHERATAAN: "Sherataan" }[company] || company);
export const monthLabel = (month) => new Date(`${month}-01T12:00:00`).toLocaleDateString("en-IN", { month: "long", year: "numeric" });

export async function generateSummary(payload, signal, onEvent) {
  const token = localStorage.getItem("access_token");
  const response = await fetch(`${API}/reports/ai/generate`, {
    method: "POST", credentials: "include", signal,
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(formatApiError(body.detail) || `Summary request failed (HTTP ${response.status}). Please retry.`);
  }
  if (!response.body) throw new Error("Streaming is unavailable in this browser.");
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "", completed = false;
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      let boundary;
      while ((boundary = buffer.indexOf("\n\n")) >= 0) {
        const frame = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        const lines = frame.split("\n");
        const event = lines.find((line) => line.startsWith("event: "))?.slice(7);
        const raw = lines.filter((line) => line.startsWith("data: ")).map((line) => line.slice(6)).join("\n");
        if (!event || !raw) continue;
        const data = JSON.parse(raw);
        if (event === "error") throw new Error(data.detail);
        if (event === "done") completed = true;
        onEvent(event, data);
      }
      if (done) break;
    }
    if (!completed) throw new Error("Connection interrupted. The summary was not confirmed saved; please check saved reports before retrying.");
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}

export function downloadSummary(report) {
  const heading = `${monthLabel(report.month)} · ${companyLabel(report.company)}`;
  const text = `# Navaratnaa HRMS — ${heading}\n\n${report.content}\n\nGenerated: ${report.created_at}\nModel: OpenAI ${report.model}\nData captured: ${report.snapshot.captured_at}\n\n## Source totals\n\n${JSON.stringify(report.snapshot, null, 2)}`;
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url; link.download = `hr-summary-${report.month}-${report.company.toLowerCase()}.txt`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}